import { deSerialize, serialize } from "@/shared/utils/serialization";

import type { IOfflineStorage } from "./OfflineStorage";

export class HTML5LocalCache implements IOfflineStorage {
    constructor() {}

    public read(key: string): any {
        const serializedValue = localStorage.getItem(key);

        if (serializedValue == null) return null;

        return deSerialize(serializedValue);
    }

    public write(key: string, value: any): void {
        const serializedValue = serialize(value);
        localStorage.setItem(key, serializedValue);
    }

    public readString(key: string): string | null {
        return localStorage.getItem(key);
    }

    public writeString(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    public static getClassName(): string {
        return "HTML5LocalCache";
    }
}
